/* eslint-disable import/prefer-default-export */

export { default as checkIfIsInTheSameLine } from './checkIfIsInTheSameLine'
export { default as getPositionInLine } from './getPositionInLine'
